import React from 'react';
import { Link } from '@/components/LocalizedLink';
import { ExternalLink, Lock, MapPin } from 'lucide-react';
import { useApiData } from '@/hooks/useApiData';

const B2B_PLATFORMS = [
  { name: 'Alibaba.com', url: 'https://www.alibaba.com' },
  { name: 'Go4WorldBusiness', url: 'https://www.go4worldbusiness.com' },
  { name: 'ExportersIndia', url: 'https://www.exportersindia.com' },
];

const CERTS = [
  { label: 'FSSAI', number: '10018022007595' },
  { label: 'IEC', number: 'CNUPK2717H' },
  { label: 'GST', number: '27CNUPK2717H1ZM' },
  { label: 'APEDA Registered' },
];

const NO_ITEMS = [];

export function MarketLinks() {
  const { data: markets } = useApiData('/api/landing-pages', NO_ITEMS);
  if (markets.length === 0) return null;
  return (
    <div className="mt-10 pt-8 border-t border-cream-muted/10" data-testid="footer-markets">
      <p className="text-[10px] uppercase tracking-[0.2em] text-cream-muted/50 font-sans font-semibold mb-3">Spice Powder Exports by Country</p>
      <div className="flex flex-wrap gap-x-5 gap-y-2">
        {markets.map(m => (
          <Link key={m.slug} to={`/market/${m.slug}`} className="inline-flex items-center gap-1 text-sm text-cream-muted/70 hover:text-saffron transition-colors font-sans" data-testid={`footer-market-${m.slug}`}>
            <MapPin size={11} /> {m.country}
          </Link>
        ))}
      </div>
    </div>
  );
}

export function B2BPlatforms() {
  return (
    <div className="mt-10 pt-8 border-t border-cream-muted/10" data-testid="b2b-platforms">
      <p className="text-[10px] uppercase tracking-[0.2em] text-cream-muted/50 font-sans font-semibold mb-3">Also Find Us On</p>
      <div className="flex flex-wrap gap-3">
        {B2B_PLATFORMS.map(p => (
          <a
            key={p.name}
            href={p.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-wider text-cream-muted/60 border border-cream-muted/15 px-4 py-2 rounded font-sans hover:text-saffron hover:border-saffron/30 transition-colors"
            data-testid={`b2b-${p.name.replace(/\./g, '-').toLowerCase()}`}
          >
            <ExternalLink size={10} /> {p.name}
          </a>
        ))}
      </div>
    </div>
  );
}

export function FooterBottom() {
  return (
    <div className="mt-8 pt-8 border-t border-cream-muted/10 flex flex-wrap items-center justify-between gap-4">
      <div className="flex flex-wrap items-center gap-3">
        {CERTS.map(cert => (
          <span key={cert.label} className="text-[10px] uppercase tracking-wider text-saffron/70 border border-saffron/20 px-3 py-1.5 rounded font-sans">
            {cert.label}{cert.number ? `: ${cert.number}` : ''}
          </span>
        ))}
        <Link
          to="/login"
          className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider text-cream-muted/30 border border-cream-muted/10 px-3 py-1.5 rounded font-sans hover:text-saffron/50 hover:border-saffron/20 transition-colors"
          data-testid="admin-login-link"
        >
          <Lock size={9} /> Admin
        </Link>
      </div>
      <p className="text-xs text-cream-muted/40 font-sans">&copy; 2026 ASJK Laxmi Global. All rights reserved.</p>
    </div>
  );
}
